import React from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { StyledComponentProps } from 'typings/common';

// components
import { Text } from '@ui';
import InfoTooltip from '../../InfoTooltip';

type IProps = StyledComponentProps;

const AccountPermissionsTooltip = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  return (
    <InfoTooltip
      {...props}
      tooltipContent={
        <StyledText variant="body1">
          {t('personal_info_modal.account_permissions_description')}
        </StyledText>
      }
    />
  );
};

const StyledText = styled(Text)`
  white-space: pre-line;
`;

export default AccountPermissionsTooltip;
